import Vue from 'vue'
import Vuex from 'vuex'

import config from 'SrcConfig'

import actions from './actions'
import mutations from './mutations'

import createLogger from './plugins/logger'
// import devtool from './plugins/devtool'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    $account: null,
    $locale: config.locale,
    $uploadProgress: 0,
    $downloadProgress: 0,
    $offline: false,
    breadcrumb: [],
    selectedRestaurantId: null,
    restaurants: [],
    menuEditorLink: null,
    ClientTypeID: null,
    $businessProfile:{},
    firebaseNotif: false,
    requiredPin: false,
    initialAutoLogoutTimer: false,
    autoLogoutTimerValue: 90,
  },
  actions,
  mutations,
  strict: debug,
  getters: {
    businessProfileGetter: state => {
      return state.$businessProfile
    }
  }
  // plugins: debug ? [createLogger()] : []
  // plugins: debug ? [createLogger(), devtool] : []
})
